import { axiosIns } from "../utils";

// The back-office moderates innovations, so it needs the ones still awaiting
// validation. `/innovations/` is the mobile listing and returns validated
// innovations only, whoever asks — pending submissions would have been
// invisible here, which is precisely what has to be reviewed.
export const fetchInnovations = async (params) => {
  const response = await axiosIns.get("/innovations/all/", { params });
  return response && response.data ? response.data : response;
};

export const fetchInnovation = async (id) => {
  const response = await axiosIns.get(`/innovations/${id}/`);
  return response && response.data ? response.data : response;
};

export const createInnovationApi = async (formData) => {
  const response = await axiosIns.post("/innovations/", formData);
  return response && response.data ? response.data : response;
};

export const updateInnovationApi = async (id, formDataOrPayload) => {
  const response = await axiosIns.patch(
    `/innovations/${id}/`,
    formDataOrPayload
  );
  return response && response.data ? response.data : response;
};

// Validation goes through the dedicated route, not PATCH /innovations/:id/:
// the generic update only accepts label, description and the picture, so
// sending `published` there reported "Innovation validée" while the innovation
// stayed a draft, invisible on mobile.
export const validateInnovationApi = async (id) => {
  const response = await axiosIns.patch(`/innovations/${id}/publish/`);
  return response && response.data ? response.data : response;
};

export const deleteInnovationApi = async (id) => {
  const response = await axiosIns.delete(`/innovations/${id}/`);
  return response && response.data ? response.data : response;
};
